import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// Suppress MessageEvent console logs from third-party scripts (e.g., Netlify Analytics)
if (process.env.NODE_ENV === 'development') {
  const originalLog = console.log;
  console.log = (...args) => {
    // Filter out MessageEvent logs
    if (args.length > 0 && args[0] && typeof args[0] === 'object' && args[0].constructor && args[0].constructor.name === 'MessageEvent') {
      return; // Suppress MessageEvent logs
    }
    // Filter out logs that are just "MessageEvent" strings
    if (args.length === 1 && args[0] === 'MessageEvent') {
      return; // Suppress simple MessageEvent string logs
    }
    originalLog.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
